module.exports = __webpack_public_path__ + "media/69.9072b437.mp3";